// extracted by mini-css-extract-plugin
export default {"circle":"bw5OGM","discountHeader":"n6iQAF"};